import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters.js'
import * as mutations from './mutations.js'
Vue.use(Vuex);
const state = { //要设置的全局访问的state对象
  visibleHeight: null,
  visibleWidth: null,
  searchHeight: null,
  paginationHeight: null,
  tableHeight: null,
  loading: false,
  whetherLoading: true,
};
const store = new Vuex.Store({
  state,
  getters,
  mutations
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js